import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    downloading: string;
    uploading: string;
    paused: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Status label when downloading */
            downloading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InProgressJobStatus.downloading?c=3r25jbvao6oon", defaultMessage: "Downloading" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Status label when uploading */
            uploading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InProgressJobStatus.uploading?c=r9sxgdwjdzde", defaultMessage: "Uploading" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Status label when transfer is paused */
            paused: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InProgressJobStatus.paused?c=ylas17etod9r", defaultMessage: "Paused" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
